import { createSelector } from 'reselect';

import { AppState } from '../../store/models/app-state';

const internalNotesState = (state: AppState) => state.internalNotes;

export const internalNotesSelector = createSelector(internalNotesState, notes => notes.notes);
export const receiptInternalNotesSelector = createSelector(internalNotesState, notes => notes.receiptNotes);
export const receiptNoteTypeSelector = createSelector(internalNotesState, notes => notes.receiptNoteType);
